/* Verzenddag, verwachte bezorging en verzendkosten bij de bestelknop (snippets/delivery-info.liquid). */
(() => {
  if (window.ivonneDeliveryInfo) return;
  window.ivonneDeliveryInfo = true;
  const DAY = 864e5;
  const root = window.Shopify?.routes?.root || '/';
  // Engels in Britse volgorde ("Tuesday 3 November"), net als de rest van de winkel
  const locale = el => ({ en: 'en-GB', nl: 'nl-NL', de: 'de-DE' })[el.dataset.locale] || el.dataset.locale || 'nl-NL';
  const money = (el, cents) => new Intl.NumberFormat(locale(el), { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const fill = (template, values) => template.replace(/\[(\w+)\]/g, (match, key) => values[key] ?? match);
  const iso = t => new Date(t).toISOString().slice(0, 10);
  const weekday = t => new Date(t).getUTCDay();
  let cartTotal = 0;
  // Na toevoegen zit de keuze al in de winkelmand; pas weer meetellen als de klant variant of aantal wijzigt
  let countSelection = true;

  // Kalenderdag (UTC-middernacht) en uur in Nederland, ongeacht de tijdzone van de bezoeker
  function now() {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).map(x => [x.type, x.value]));
    return { day: Date.UTC(+p.year, +p.month - 1, +p.day), hour: +p.hour };
  }
  // Nederlandse feestdagen waarop PostNL niet ophaalt of bezorgt
  const holidayCache = {};
  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    const a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const easter = Date.UTC(year, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    const kingsDay = Date.UTC(year, 3, 27);
    return holidayCache[year] = new Set([`${year}-01-01`, iso(weekday(kingsDay) === 0 ? kingsDay - DAY : kingsDay), iso(easter + DAY), iso(easter + 39 * DAY), iso(easter + 50 * DAY), `${year}-12-25`, `${year}-12-26`]);
  }
  const holiday = t => holidays(new Date(t).getUTCFullYear()).has(iso(t));

  function schedule(el) {
    const days = el.dataset.days.split(',').map(Number), cutoff = Number(el.dataset.cutoff || 0);
    const closed = new Set(el.dataset.closed.match(/\d{4}-\d{2}-\d{2}/g) || []);
    const { day, hour } = now();
    let ship = null;
    for (let i = 0; i < 60 && ship === null; i++) {
      const t = day + i * DAY;
      if (days.includes(weekday(t)) && !closed.has(iso(t)) && !holiday(t) && (i > 0 || hour < cutoff)) ship = t;
    }
    if (ship === null) return null;
    let arrive = null, transit = Number(el.dataset.transit || 0);
    if (transit > 0) for (arrive = ship; transit > 0;) { arrive += DAY; if (weekday(arrive) !== 0 && !holiday(arrive)) transit--; }
    return { day, ship, arrive, cutoff };
  }
  function label(el, t, today) {
    if (t === today) return el.dataset.tToday;
    if (t === today + DAY) return el.dataset.tTomorrow;
    return new Intl.DateTimeFormat(locale(el), { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(new Date(t));
  }

  function render(el) {
    const product = el.closest('[data-product]');
    const data = JSON.parse(product?.querySelector('[data-product-data]')?.textContent || '{"variants":[]}');
    const id = product?.querySelector('[data-variant-id]')?.value;
    const variant = data.variants.find(v => String(v.id) === id);
    el.hidden = !variant || (product.dataset.stockSoldOut === undefined ? !variant.available : product.dataset.stockSoldOut === 'true');
    if (el.hidden) return;

    const plan = schedule(el), shipEl = el.querySelector('[data-delivery-ship]');
    if (plan && shipEl) {
      const shipText = plan.ship === plan.day ? fill(el.dataset.tShipToday, { hour: plan.cutoff }) : fill(el.dataset.tShipLater, { day: label(el, plan.ship, plan.day) });
      shipEl.textContent = plan.arrive ? `${shipText} · ${fill(el.dataset.tArrive, { day: label(el, plan.arrive, plan.day) })}` : shipText;
    }

    const costEl = el.querySelector('[data-delivery-cost]');
    if (!costEl || el.dataset.cost === undefined) return;
    const cost = Number(el.dataset.cost), free = el.dataset.free === '' ? null : Number(el.dataset.free);
    const quantity = Math.max(1, Number(product.querySelector('input[name="quantity"]')?.value) || 1);
    const amount = cartTotal + (countSelection ? variant.price * quantity : 0);
    if (cost === 0 || (free !== null && amount >= free)) costEl.textContent = el.dataset.tFree;
    else if (free !== null) costEl.textContent = fill(countSelection ? el.dataset.tUntilFree : el.dataset.tUntilFreeCart, { cost: money(el, cost), remaining: money(el, free - amount) });
    else costEl.textContent = fill(el.dataset.tCost, { cost: money(el, cost) });
  }

  const all = () => document.querySelectorAll('[data-delivery-info]');
  const renderAll = () => all().forEach(render);
  async function loadCart() {
    try { const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }); if (r.ok) cartTotal = (await r.json()).total_price || 0; } catch {}
    renderAll();
  }
  // ivonne.js zet eerst de variant; daarom pas daarna opnieuw rekenen
  const later = event => { if (event.target.closest('[data-product]')?.querySelector('[data-delivery-info]')) { countSelection = true; setTimeout(renderAll); } };
  document.addEventListener('change', later);
  document.addEventListener('input', later);
  document.addEventListener('product:stock-changed', renderAll);
  document.addEventListener('cart:updated', event => { cartTotal = event.detail?.total_price || 0; countSelection = false; renderAll(); });
  document.addEventListener('shopify:section:load', loadCart);
  setInterval(renderAll, 5 * 60 * 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadCart); else loadCart();
})();
